export default __webpack_public_path__ + "static/media/image23.2b728312.png";